import { QueryStatus } from '@adv-frontend/modules-query';

export const isQueryStatusResolved = (status: QueryStatus): boolean =>
    status === QueryStatus.fulfilled || status === QueryStatus.rejected;
